module.exports = __webpack_public_path__ + "static/img/11.060e3b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/20/eng/11.png
// module id = RDVf
// module chunks = 0